import React from "react";

const DataAgregatPenumpang = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Dashboard Agregat Penumpang"
        src="https://lookerstudio.google.com/embed/reporting/e20fe036-e5c2-4977-ae58-2dc147648bf2/page/daSTD"
          width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default DataAgregatPenumpang;
